import React from 'react'
import { Button } from '@surecompanies/core_components'
import { Drawer } from 'antd'
import {
  PaymentAssignmentStatusId,
  PaymentFilters,
  PaymentType,
  Priority,
  TerminatedFilter,
  TestUserFilter,
  PersonRelationshipEnum,
} from '../Utils/types'
import type { PaymentAssignmentRolePolicy } from '../Utils/rolePolicy'
import { DrawerFooter } from './styles'
import type { FilterUpdateFn, UserOption } from './types'
import DrawerSectionPaymentStatus from './DrawerSectionPaymentStatus'
import DrawerSectionCompanyCarrier from './DrawerSectionCompanyCarrier'
import DrawerSectionAssignee from './DrawerSectionAssignee'
import DrawerSectionBenefitDates from './DrawerSectionBenefitDates'
import DrawerSectionUserStatus from './DrawerSectionUserStatus'

interface PaymentAssignmentFilterDrawerProps {
  open: boolean
  onClose: () => void
  onSearch: () => void
  clearAllFilters: () => void
  filters: PaymentFilters
  updateFilter: FilterUpdateFn
  rolePolicy: PaymentAssignmentRolePolicy
  isRoleFilterLocked: boolean

  statusOptions: PaymentAssignmentStatusId[]
  statusesValue: string[]

  paymentTypes: string[]
  paymentTypesValue: (string | PaymentType)[]
  paymentTypeScope: string[]
  setPaymentTypeSearch: (v: string) => void

  priorityLevelsValue: Priority[]
  priorityScope: Priority[]
  setPrioritySearch: (v: string) => void

  paymentSubmittedByIdsValue: number[]
  paymentSubmittedByOptions: UserOption[]
  usersLoading: boolean
  checkersLoading: boolean

  terminatedFilterValue: TerminatedFilter
  testUserFilterValue: TestUserFilter

  clientPublicKeysValue: string[]
  companyOptions: { label: string; value: string }[]
  companyScopeValues: string[]
  setCompanySearch: (v: string) => void

  carriersValue: string[]
  carrierOptions: string[]
  carrierScopeNames: string[]
  carriersLoading: boolean
  setCarrierSearch: (v: string) => void

  assigneeValue: number[]
  userOptions: UserOption[]

  escalatorValue: number[]
  escalatorOptions: UserOption[]
  escalatorsLoading: boolean

  relationshipsValue: PersonRelationshipEnum[]
  binderPaymentValue: boolean | undefined
  primaryPaymentMethodsValue: string[]
}

export default function PaymentAssignmentFilterDrawer({
  open,
  onClose,
  clearAllFilters,
  filters,
  updateFilter,
  rolePolicy,
  isRoleFilterLocked,
  statusOptions,
  statusesValue,
  paymentTypes,
  paymentTypesValue,
  paymentTypeScope,
  setPaymentTypeSearch,
  priorityLevelsValue,
  priorityScope,
  setPrioritySearch,
  paymentSubmittedByIdsValue,
  paymentSubmittedByOptions,
  usersLoading,
  checkersLoading,
  terminatedFilterValue,
  testUserFilterValue,
  clientPublicKeysValue,
  companyOptions,
  companyScopeValues,
  setCompanySearch,
  carriersValue,
  carrierOptions,
  carrierScopeNames,
  carriersLoading,
  setCarrierSearch,
  assigneeValue,
  userOptions,
  escalatorValue,
  escalatorOptions,
  escalatorsLoading,
  relationshipsValue,
  binderPaymentValue,
  primaryPaymentMethodsValue,
}: PaymentAssignmentFilterDrawerProps) {
  return (
    <Drawer
      title="Filters"
      placement="right"
      onClose={onClose}
      open={open}
      width={380}
      footer={
        <DrawerFooter>
          <Button
            type="primary"
            onClick={() => {
              onClose()
            }}
          >
            Apply Filters
          </Button>
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              clearAllFilters()
            }}
          >
            Reset all
          </span>
        </DrawerFooter>
      }
    >
      <DrawerSectionPaymentStatus
        statusOptions={statusOptions}
        statusesValue={statusesValue}
        updateFilter={updateFilter}
        paymentTypes={paymentTypes}
        paymentTypesValue={paymentTypesValue}
        paymentTypeScope={paymentTypeScope}
        setPaymentTypeSearch={setPaymentTypeSearch}
        priorityLevelsValue={priorityLevelsValue}
        priorityScope={priorityScope}
        setPrioritySearch={setPrioritySearch}
        paymentSubmittedByIdsValue={paymentSubmittedByIdsValue}
        paymentSubmittedByOptions={paymentSubmittedByOptions}
        usersLoading={usersLoading}
        checkersLoading={checkersLoading}
        terminatedFilterValue={terminatedFilterValue}
        relationshipsValue={relationshipsValue}
        binderPaymentValue={binderPaymentValue}
        primaryPaymentMethodsValue={primaryPaymentMethodsValue}
      />

      <DrawerSectionCompanyCarrier
        clientPublicKeysValue={clientPublicKeysValue}
        companyOptions={companyOptions}
        companyScopeValues={companyScopeValues}
        setCompanySearch={setCompanySearch}
        updateFilter={updateFilter}
        carriersValue={carriersValue}
        carrierOptions={carrierOptions}
        carrierScopeNames={carrierScopeNames}
        carriersLoading={carriersLoading}
        setCarrierSearch={setCarrierSearch}
      />

      <DrawerSectionAssignee
        rolePolicy={rolePolicy}
        isRoleFilterLocked={isRoleFilterLocked}
        assigneeValue={assigneeValue}
        userOptions={userOptions}
        usersLoading={usersLoading}
        escalatorValue={escalatorValue}
        escalatorOptions={escalatorOptions}
        escalatorsLoading={escalatorsLoading}
        updateFilter={updateFilter}
      />

      <DrawerSectionBenefitDates
        filters={filters}
        updateFilter={updateFilter}
      />

      <DrawerSectionUserStatus
        testUserFilterValue={testUserFilterValue}
        updateFilter={updateFilter}
      />
    </Drawer>
  )
}
